import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './i18n';
import './App.css';

// Components
import LoadingSpinner from './components/UI/LoadingSpinner';
import ChatApp from './components/Chat/ChatApp';
import AdminApp from './components/Admin/AdminApp';
import AuthTest from './components/Debug/AuthTest';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Ensure document direction is always LTR
    document.dir = 'ltr';
    
    // Simulate app initialization
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="App h-screen overflow-hidden">
      <Router basename={window.__REACT_ROUTER_BASENAME__ || ''}>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<ChatApp />} />
            <Route path="/admin" element={<AdminApp />} />
            <Route path="/admin/reset-password" element={<AdminApp />} />
            <Route path="/debug" element={<AuthTest />} />
            <Route path="*" element={<ChatApp />} />
          </Routes>
        </Suspense>
      </Router>
      
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'linear-gradient(135deg, rgba(107, 114, 128, 0.9) 0%, rgba(59, 130, 246, 0.9) 100%)',
            color: '#fff',
            borderRadius: '12px',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          },
          success: {
            style: {
              background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.9) 0%, rgba(59, 130, 246, 0.9) 100%)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            },
          },
          error: {
            style: {
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.9) 0%, rgba(107, 114, 128, 0.9) 100%)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            },
          },
        }}
      />
    </div>
  );
}

export default App; 